import { render } from "./SkeletonMiniWizardBottomBar.vue?vue&type=template&id=d66b5c56"
import script from "./SkeletonMiniWizardBottomBar.vue?vue&type=script&lang=js"
export * from "./SkeletonMiniWizardBottomBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__